import { render, staticRenderFns } from "./StatsGlobales.vue?vue&type=template&id=7ee2fd2d&"
import script from "./StatsGlobales.vue?vue&type=script&lang=js&"
export * from "./StatsGlobales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports